export { default as MemorandumsPage  } from "./MemorandumsPage";
export { default as MemorandumPage  } from "./MemorandumPage";
